import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCAdv2Page() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-4763" data-mp="1c30oyaee9c0g">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-4764" data-mp="176s9evwabgsr">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-4765" data-mp="feugfcecpzgw">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-4766" data-mp="oe7r28e7ou37">
              <XIcon className="w-6 h-6" data-id="element-4767" data-mp="24uao0ncmnd4o" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-4768" data-mp="1zs1wzwjbel57">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-advertorial-2" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-4769" data-mp="2wcdenispn5cc"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-4770" data-mp="2ilia2ip8vaek">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-4771" data-mp="2nhpa5uuylrol">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-4772" data-mp="2sb1u3rop1ab0" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-4773" data-mp="1rs875kixxtsl">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-4774" data-mp="1wjq6631elkax">
        <div className="flex justify-center md:justify-between items-center" data-id="element-4775" data-mp="18uffjedrp6ai">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-4776" data-mp="18wi37rrg6nc2" />
          <div className="hidden md:block" data-id="element-4777" data-mp="1dsz29h06qm3x">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-4778" data-mp="1drxgahhmsf7f">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-4779" data-mp="31qzsqr0e05mz">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-4780" data-mp="2rv678i4ox1t2">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-4781" data-mp="3fjz72pofntsy">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-4782" data-mp="2c5wv04mklnr">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-4783" data-mp="2fl8gtbeuh4pg">
        <div className="md:col-span-7" data-id="element-4784" data-mp="2amx8540ad08t">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-4785" data-mp="25l7t7d9y02fg">
            Gratis Online Webinar: Communiceren met je Hond
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1a2b4a] mb-6 leading-tight" data-id="element-4786" data-mp="21miixtk7b101">
            Wat probeert je hond je te zeggen?
          </h1>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-4787" data-mp="2tcmzfh4ub3vz">
            Inschrijven webinar
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-4788" data-mp="3h1y1r31u96c8">
            <div className="flex -space-x-3" data-id="element-4789" data-mp="3c9xxiyeqjr9u">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4790" data-mp="3c8wikiulmkmu" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4791" data-mp="17ryqre1qdptp" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4792" data-mp="1hobja8ljhxmv" />
            </div>
            <div data-id="element-4793" data-mp="1vgrgutvo93ge">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-4794" data-mp="1vhatpw6gt1nk">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-4795" data-mp="20hyngpm2vwlh">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-4796" data-mp="25dnoyyhnrnkf">
            Ontdek in dit gratis 90-minuten webinar de eenvoudige, liefdevolle
            methode die duizenden hondenbaasjes nu gebruiken om hun hond te
            begrijpen.
          </p>

          <ul className="space-y-4 mb-8" data-id="element-4797" data-mp="f4c0zqyxbs4u">
            {['Waarom je hond doet wat hij doet - en waarom je het tot nu toe verkeerd hebt begrepen', 'De taal van je hond - leer de signalen lezen van je hond zodat je ziet wat hij denkt, voelt en wilt', 'Wat angst, stress en onzekerheid werkelijk betekenen - en hoe je ze herkent', 'Waarom "ongehoorzaamheid" een mythe is - en hoe je zorgt dat jou hond weet wat je van hem wilt', 'Hoe je de wereld vanuit je hond ziet - zodat je "onverklaarbaar gedrag" ineens begrijpt', 'De 3 kernbehoeften van elke hond - en hoe deze je helpen om een rustigere blijere hond te krijgen'].map((item, i) => <li key={i} className="flex items-start" data-id="element-4798" data-mp="2ux1a5u6owd6y" data-mpi={i}>
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-4799" data-mp="1adyu8nfv2jde" />
                <span className="text-gray-700 font-medium" data-id="element-4800" data-mp="1fc0fnf0reus1">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-4801" data-mp="10mb8n35zjwju">
            <div className="flex -space-x-3" data-id="element-4802" data-mp="15lff3m1izg6h">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4803" data-mp="15k4e1tzgsmj2" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4804" data-mp="hoi4jxjmlgkv" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4805" data-mp="2c2ssm3sec6pl" />
            </div>
            <div data-id="element-4806" data-mp="ztpagc5wknds">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-4807" data-mp="zt65dw1cpth6">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-4808" data-mp="v15x9gb4nu9i">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-4809" data-mp="l3ru2ie7t1z5">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-4810" data-mp="l5bbwdfirl31">
            <div className="flex justify-center items-center w-full" data-id="element-4811" data-mp="h1wtjg43ysmf">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-advertorial-2" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-4812" data-mp="c322xrzwfzrr"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-4813" data-mp="2irc5d3lowpfp">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-4814" data-mp="2isdjxi1wzu26">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-4815" data-mp="2nq5kf0gmkohz">
            Leer de taal van je hond in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-4816" data-mp="1q47vak7qpkx2">
            <div className="flex flex-col items-center" data-id="element-4817" data-mp="1v180kswrmjn4">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-4818" data-mp="1v3u9avve756x" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4819" data-mp="3bg9lp16ccc5t">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-4820" data-mp="3bic8zdg3zr6u">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-4821" data-mp="36k7xibr8fwb2">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-4822" data-mp="36hlpkb0fjesb" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4823" data-mp="3k9rvl49vc5e1">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-4824" data-mp="2nl2e3f25lesl">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-4825" data-mp="2wl8nopuqdumh">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-4826" data-mp="2wjnscy0le7nk" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4827" data-mp="gu4a8fl0myjt">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-4828" data-mp="gw79zrbz061q">
                Leer in 90 minuten hoe je de taal van je hond leert spreken
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-4829" data-mp="1weddtx8an7es">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-4830" data-mp="1ijazqmtambqw">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-4831" data-mp="1dlj3xhpj25hf">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-4832" data-mp="18n7w1cism51u">
            Duizenden baasjes gingen je voor - en zeggen allemaal hetzelfde:{' '}
            <br data-id="element-4833" data-mp="331ijbgjqor5i" />
            <span className="italic" data-id="element-4834" data-mp="3320ox3sakhq3">"Ik begrijp mijn hond nu pas echt."</span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-4835" data-mp="2y3h4j7tcjdzu">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4836" data-mp="wd8ig9dlk9jo">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4837" data-mp="wb5j2yqk142a">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-4838" data-mp="mg3wa9jr4e2v"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4839" data-mp="3qshhbvdr1v8t">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4840" data-mp="3uv49xyi8vk72">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-4841" data-mp="3nd62dzjmij6h"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4842" data-mp="39jydwgqua3t0">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4843" data-mp="39hvej63sqybm">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-4844" data-mp="2gu7txr2j07oz"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-4845" data-mp="2bv257p4lwhlw">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4846" data-mp="2bvv2lzhodurd">
              <div className="flex items-center mb-4" data-id="element-4847" data-mp="2gtmvavq59kwm">
                <div className="flex text-green-500 mr-2" data-id="element-4848" data-mp="hhkexucth6n6">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4849" data-mp="mfc6gn9juqqu" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4850" data-mp="exo25dkzhtdw">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4851" data-mp="a5mgj11xeqb7">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4852" data-mp="801mekmmyr8">
                Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
                Maar bij onze laatste herplaatser hebben we wel hulp nodig. In
                kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
                enthousiast over deze cursus en ik kreeg ook veel hulp
                aangeboden. Het is netjes overzichtelijk, duidelijk maar wat met
                het meeste aanspreekt is dat het zonder commando's gaat maar via
                communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4853" data-mp="34ly7uzf1umid">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4854" data-mp="364583bpjalwh">
              <div className="flex items-center mb-4" data-id="element-4855" data-mp="3b2ghjlbx2ue6">
                <div className="flex text-green-500 mr-2" data-id="element-4856" data-mp="3b03zl865sk14">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4857" data-mp="2w7ad32sgz3my" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4858" data-mp="2ncvxez411r3b">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4859" data-mp="2s3c9aes794nk">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4860" data-mp="2dey808aflo94">
                Amée is een zeer lieve vrouw met een hart voor honden en dat
                merk je zeer goed. De tips helpen echt. Ik raad iedereen met
                puppy's, jongere hondjes en alle andere leeftijden deze cursus
                aan, vooral mensen die problemen hebben met hun troetel. Zowel
                gedragsproblemen als medische problemen. Volg even de gratis
                Masterclass en je bent volledig overtuigd van de cursus en de
                mensen erachter. Heel veel liefs aan iedereen van het team.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4861" data-mp="1ysir38ywafye">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4862" data-mp="1tuze0cdxo981">
              <div className="flex items-center mb-4" data-id="element-4863" data-mp="28nssbuhgyjb4">
                <div className="flex text-green-500 mr-2" data-id="element-4864" data-mp="23prcrjj9524e">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4865" data-mp="2hgxj9zky800s" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4866" data-mp="2dh5gy4m5eq3v">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4867" data-mp="2rh6fveiurngp">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4868" data-mp="3tu13fce9dkoy">
                Dit was de eerste keer dat ik een online hondencursus volgde en
                ik heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
                prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
                kan doen ivm de communicatie. Dat is gelukt, het valt echt op
                dat omdat ik mij zelf anders opstel, mijn honden nu veel
                rustiger communiceren met andere honden. Vooral met onbekende
                honden was er toch vaak wel flink geblaf. Nu bijna niet meer,
                heerlijk, wat is wandelen toch/weer een genot. Idd: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4869" data-mp="3ouxyrt26xghi">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4870" data-mp="2rer43r1fycut">
              <div className="flex items-center mb-4" data-id="element-4871" data-mp="2wd2dk0ntqlci">
                <div className="flex text-green-500 mr-2" data-id="element-4872" data-mp="2oukq0qj4560j">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4873" data-mp="2jv888k73mp4t" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4874" data-mp="2evvgpm5a8tvw">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4875" data-mp="29yd8xz304kph">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4876" data-mp="25xb7rcpixykv">
                Ik vond het prettig mijn ervaring op te halen en voorbereid te
                zijn op de puppy die ik al snel krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4877" data-mp="1r7card9pgt6z">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-4878" data-mp="1m77thl0z3ufp">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-4879" data-mp="221ujfzwsify">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-4880" data-mp="3u6vvp6u33hik">
          <div data-id="element-4881" data-mp="3p93z3zihv781">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-4882" data-mp="3p7j3e6kg1i8l">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-4883" data-mp="3fj13rsnwhh6j">
              <p data-id="element-4884" data-mp="3fgoeeuftc4jg">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. Maar veel belangrijker: ik ben iemand die
                precies begrijpt wat je voelt als je hond je frustreert en je
                niet weet hoe je hem beter kunt begrijpen.
              </p>
              <p data-id="element-4885" data-mp="2wk6rqrftmuu2">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes en
                hun honden mogen begeleiden. Niet om hen te 'trainen' in de
                traditionele zin, maar om hen te helpen wat ik zelf ook ontdekt
                heb: dat echte verandering begint met communicatie, niet met
                commando's.
              </p>
              <p data-id="element-4886" data-mp="1ly7m1s5nk0oe">
                Wat ik in al die jaren heb gezien, is dat de meeste frustratie
                niet voortkomt uit een 'slecht' hond of een 'falende' baas. Het
                komt voort uit onbegrip. Uit het feit dat baasjes en honden
                letterlijk twee verschillende talen spreken. Zodra je die taal
                van je hond leert, verdwijnt de frustratie. De strijd maakt
                plaats voor samenwerking. En de band wordt onverwoestbaar.
              </p>
              <p data-id="element-4887" data-mp="174mbcx0p3otz">
                Daarom werk ik uitsluitend met methodes die gebaseerd zijn op
                vertrouwen, veiligheid, wederzijds respect en echte
                communicatie. Geen dwang, geen pijn, geen angst, geen straf.
                Alleen liefde en begrip. Want dat is wat zowel jij als je hond
                verdienen.
              </p>
              <p data-id="element-4888" data-mp="1cxrxt5ncx65p">
                Dit webinar is mijn manier om dit geheim met zoveel mogelijk
                hondenbaasjes te delen. Omdat ik geloof dat elke hond en elke
                mens de kans verdient om elkaar écht te begrijpen.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-4889" data-mp="yzbemf8b5n6o">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-4890" data-mp="tzytq00zyq6q" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-4891" data-mp="2jdlr5lpgb1hr">
        <div className="max-w-md mx-auto px-4" data-id="element-4892" data-mp="2jggdjis0ywdt">
          <div className="p-6 rounded-3xl w-full" data-id="element-4893" data-mp="2fdjphcjpu82h">
            <div className="flex justify-center items-center" data-id="element-4894" data-mp="2feux5nga7zyv">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-advertorial-2" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-4895" data-mp="2mvhy7eu2pf4n"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-4896" data-mp="2vwz8uhopooly">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-4897" data-mp="2vwpj8v7kwjgs">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-4898" data-mp="30uhmgldobs0a" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-4899" data-mp="25o1uy6n3ainr">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-4900" data-mp="20offdqjsgqbs">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-4901" data-mp="1qqspya4v5gdk">
            <p className="mb-2" data-id="element-4902" data-mp="1qsvpbkrwoluy">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-4903" data-mp="2jfgdydgzyjut">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-4904" data-mp="3eplb8squ8tlu" />
    </div>;
}